import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Privacy: React.FC = () => {
    const navigate = useNavigate();
    
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={0} sx={{ p: 4, borderRadius: 2 }}>
                <Button 
                    startIcon={<ArrowBackIcon />} 
                    onClick={() => navigate(-1)} 
                    sx={{ mb: 3 }}
                >
                    Back
                </Button>
                
                <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
                    Privacy Policy
                </Typography>
                
                <Typography variant="body1" paragraph>
                    Welcome to our Privacy Policy page. Your privacy is critically important to us.
                </Typography>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        1. Information We Collect
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We collect various types of information in connection with the services we provide, including:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2 }}>
                        <Typography component="li" variant="body1" paragraph>
                            Information you provide directly to us.
                        </Typography>
                        <Typography component="li" variant="body1" paragraph>
                            Information we collect about your use of our services.
                        </Typography>
                        <Typography component="li" variant="body1" paragraph>
                            Information we obtain from third-party sources.
                        </Typography>
                    </Box>
                </Box>
                
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" component="h2" gutterBottom fontWeight="600">
                        2. How We Use Information
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We use the information we collect in various ways, including to:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2 }}>
                        <Typography component="li" variant="body1" paragraph>
                            Provide, operate, and maintain our services.
                        </Typography>
                        <Typography component="li" variant="body1" paragraph>
                            Improve, personalize, and expand our services.
                        </Typography>
                        <Typography component="li" variant="body1" paragraph>
                            Understand and analyze how you use our services.
                        </Typography>
                        <Typography component="li" variant="body1" paragraph>
                            Develop new products, services, features, and functionality.
                        </Typography>
                    </Box>
                </Box>
                
                <Box sx={{ mt: 5, textAlign: 'center' }}>
                    <Button variant="contained" onClick={() => navigate('/')} sx={{ mx: 1 }}>
                        Back to Home
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default Privacy;